import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-x-large);
	align-items: center;
	justify-content: center;

	.bar-chart {
		width: var(--px-840);
	}

	.two-line-ellipse {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: initial;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
`;
